import React from 'react';
import { MainPageLayout } from '../layout/MainPageLayout';
import { FactoryNavigationBar } from '../component/navigation-bar/FactoryNavigationBar';
import { FactoryDiv } from '../component/factory-dashboard/FactoryDiv';

export const FactoryPage = () => (
  <MainPageLayout
    navigationBar={<FactoryNavigationBar />}
    elementCentr={<FactoryDiv />}
  />
);
